import {ApiRequestor} from "@/classes/requestors/api.requestor";

export class DtoApiSaveLoginPreferenceRequest extends ApiRequestor {
    data;

    status;

    async $post(params) {
        return this.$http('POST', `/users/profile/login-preference`, {params})
    }
}